/**
 * Sérialise des paramètres de requête pour les appels hors client axios
 * (téléchargements de fichiers, qui passent par `fetch`).
 *
 * Les tableaux sont émis en `key[]=a&key[]=b`, la forme attendue par les
 * filtres communs du contrat et celle que produit axios par défaut ailleurs.
 */
type QueryValue = string | number | string[] | undefined;

export const toQueryString = (params: Record<string, QueryValue>): string => {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) continue;
    if (Array.isArray(value)) {
      value.forEach(entry => search.append(`${key}[]`, entry));
    } else {
      search.append(key, String(value));
    }
  }
  const query = search.toString();
  return query ? `?${query}` : '';
};
